export const traverseMap: { parent: string; path: string }[] = [];
